<template>
  <div class="layout">
    <el-container style="height: 100vh">
      <el-aside width="220px">
        <div class="logo">高小畅后台</div>
        <el-menu
          :default-active="$route.path"
          class="el-menu-vertical-demo"
          background-color="#001529"
          text-color="#bfcbd9"
          active-text-color="#409EFF"
          @select="handleMenuSelect"
        >
          <el-menu-item index="/dashboard">数据总览</el-menu-item>
          <el-menu-item index="/users">用户管理</el-menu-item>
          <el-menu-item index="/merchants">商家管理</el-menu-item>
          <el-menu-item index="/news">资讯与内容</el-menu-item>
          <el-menu-item index="/banners">轮播图管理</el-menu-item>
          <el-menu-item index="/navs">功能图标管理</el-menu-item>
          <el-menu-item index="/checkin/audit">打卡审核</el-menu-item>
          <el-menu-item index="/promo/coupons">优惠券管理</el-menu-item>
          <el-submenu index="/system">
            <template slot="title">系统管理</template>
            <el-menu-item index="/system/admin-users">管理员账号</el-menu-item>
            <el-menu-item index="/system/customer-service">客服电话</el-menu-item>
            <!-- <el-menu-item index="/system/configs">系统配置</el-menu-item> -->
            <el-menu-item index="/system/logs">操作日志</el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-container>
        <el-header class="header">
          <span>高小畅管理后台</span>
          <div class="header-right">
            <div v-if="isLoggedIn" class="user-entry" @click="onLogout">
              <div class="avatar">{{ avatarText }}</div>
              <div class="user-text">
                <div class="name">{{ adminUsername }}</div>
                <div class="role" v-if="adminRole">{{ adminRole }}</div>
              </div>
            </div>
            <div v-else class="login-entry" @click="goLogin">点击登录</div>
          </div>
        </el-header>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'AdminLayout',
  data() {
    return {
      adminUsername: window.localStorage.getItem('admin_username') || '管理员',
      adminRole: window.localStorage.getItem('admin_role') || ''
    }
  },
  computed: {
    isLoggedIn() {
      return !!window.localStorage.getItem('admin_token')
    },
    avatarText() {
      const name = this.adminUsername || '管'
      return String(name).slice(0, 1).toUpperCase()
    }
  },
  watch: {
    '$route.path'() {
      // 登录后刷新一下展示信息
      this.adminUsername = window.localStorage.getItem('admin_username') || '管理员'
      this.adminRole = window.localStorage.getItem('admin_role') || ''
    }
  },
  methods: {
    handleMenuSelect(index) {
      if (index !== this.$route.path) {
        this.$router.push(index)
      }
    },
    goLogin() {
      this.$router.push('/login')
    },
    onLogout() {
      this.$confirm('确认退出登录？', '提示', {
        type: 'warning'
      })
        .then(() => {
          window.localStorage.removeItem('admin_token')
          window.localStorage.removeItem('admin_username')
          window.localStorage.removeItem('admin_role')
          this.$router.replace('/login')
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.logo {
  height: 64px;
  line-height: 64px;
  text-align: center;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
  background: #002140;
}
.el-menu-vertical-demo {
  height: calc(100vh - 64px);
  overflow: auto;
  border-right: none;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}
.user-entry {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
}
.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #409EFF;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
}
.user-text .name {
  font-size: 14px;
  line-height: 16px;
}
.user-text .role {
  font-size: 12px;
  color: #909399;
  line-height: 14px;
}
.login-entry {
  cursor: pointer;
  color: #409EFF;
  user-select: none;
}
</style>

